<template>
  <div class="box">
    <headerpage></headerpage>
    <section id="hero" class="mt-4" style="min-height: 494px">
      <div class="container">
        <div class="text-left">

          <br>
          <h2>产品说明</h2>
          <p><b>{{this.common.name}}，是全新的互联网安全加速应用。</b></p>

          <p>
            它能够在复杂的网络环境下迅速为您打开安全专属的信息传输通道，提高跨网访问各个运营商网络的速度和质量。连接{{this.common.name}}，视频语音通话、看视频、玩游戏、听音乐都将获得更佳体验，助您玩转更多APP。单用户独享带宽，尊享手机/PAD/电脑/电视多终端使用。
          </p>

          <br>
          <h4>产品优势</h4>
          <p>自动连接速度最快的接入节点，直接专线接入骨干网络，减少路由跳转，提升访问速度。</p>

          <br>
          <h4>全硬件构建&amp;畅通无阻</h4>
          <p>整体网络采取万兆接入标准构建，使用全球知名厂商的全硬件解决方案构建。</p>

          <br>
          <h4>全程链接&amp;安全加密</h4>
          <p>降低用户数据被非法窃取的可能性，全程数据传输采用加密方式。</p>

          <br>
          <h4>使用便捷&amp;全平台支持</h4>
          <p>支持IOS、Android和Windows系统，单用户独享带宽，尊享手机/PAD/电脑/电视多终端使用。</p>


        </div>


      </div>
    </section>
    <footerComponent :showbeian="false"></footerComponent>
  </div>
</template>

<script>
import headerpage from "@/components/header";
import footerComponent from "@/components/footer";

export default {
  name: "answerPage",
  components: {headerpage, footerComponent}
}
</script>

<style scoped lang="scss">
.topmargin-lg {

  a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
  }

}

#hero {
  text-align: center;
  font-size: 16px;
  margin-top: 10px;

}

#hero h1 {
  font-size: 46px;
  margin-bottom: 30px;
}

#hero p {
  margin-bottom: 20px;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #282c47;
}

#footer {
  background-color: #282c47;
  text-align: center;
  padding: 80px 0 30px 0;
}

#footer h3 {
  color: #ffffff;
  margin-bottom: 25px;
}

#footer i {
  font-size: 20px;
  color: #5b617c;
  margin: 0 5px;
}

* {
  color: #5b617c;
  font-family: 'Roboto', sans-serif;
}

.btn-primary {
  color: white;
  margin: 5px;
  padding: 15px;
}
</style>